import { Component, inject } from '@angular/core';
import { Router, RouterModule } from '@angular/router';
import { AuthenticationService } from '../../../shared/authentication-service';
import { CommonModule } from '@angular/common';
import { IonicModule } from '@ionic/angular';
import { FormsModule } from '@angular/forms';
@Component({
  selector: 'app-firebase-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss'],
  standalone: true,
  imports: [IonicModule, RouterModule, CommonModule, FormsModule]
})
export class FirebaseLoginComponent {
  public authService = inject(AuthenticationService);
  public router = inject(Router);

  constructor() {}

  logIn(email: any, password: any) {

    this.authService.SignOut(false);

    this.authService
      .SignIn(email.value, password.value)
      .then((): any => {
        if (this.authService.isEmailVerified) {
          this.router.navigate(['submissions']);
        } else {
          window.alert('Email is not verified');
          return false;
        }
      })
      .catch((error) => {
        window.alert(error.message);
      });
  }

  linkCredential(email: any, password: any) {
    this.authService.LinkWithCredential(email.value, password.value)
    .then((): any => {
      if (this.authService.isEmailVerified) {
        this.router.navigate(['submissions']);
      } else {
        window.alert('Email is not verified');
        return false;
      }
    })
    .catch((error) => {
      window.alert(error.message);
    });
  }
}